import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";

export default function BankInfoDialog(props) {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [relatedBrandList, setRelatedBrandList] = useState([]);
  const [categoryLists, setCategoryLists] = useState([]);
  const [subCategoryLists, setSubCategoryLists] = useState([]);

  const [procode, setProCode] = useState("");
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");

  const [relatedBrand, setRelatedBrand] = useState("");

  const [description, setDescription] = useState("");
  const [error, setError] = useState({
    name: "",
    procode: "",
    category: "",
    subCategory: "",
    relatedBrand: "",
    description: "",
  });
  const ProMedicineCreate = () => {
    const data = {
      name: name,
      code: procode,
      relatedCategory: category,
      relatedSubCategory: subCategory,
      relatedBrand: relatedBrand,
      description: description,
    };

    const validate = () => {
      const newErrors = {};

      if (!name.trim()) newErrors.name = "Name is required";
      if (!procode.trim()) newErrors.procode = "Product code is required";
      if (!category.trim()) newErrors.category = "Category is required";
      if (!subCategory.trim())
        newErrors.subCategory = "Sub category is required";
      if (!relatedBrand.trim()) newErrors.relatedBrand = "Brand is required";

      setError(newErrors);

      return Object.keys(newErrors).length === 0;
    };

    if (!validate()) return;
    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api.post("procedure-accessory", data, config).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "You Created Procedure accessory Data!",
        icon: "success",
        // showCancelButton: true,

        cancelButtonText: "Close",
      });

      props.setProAccessLists((prev) => [response.data.data, ...prev]);
    });
    props.close();
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const res = await api.get("categories");

        setCategoryLists(res.data.data);
      } catch (err) {}
    };
    const getSubCategory = async () => {
      try {
        const res = await api.get("sub-categories");

        setSubCategoryLists(res.data.data);
      } catch (err) {}
    };

    const getBrandLists = async () => {
      try {
        const res = await api.get("brands");
        setRelatedBrandList(res.data.data);
      } catch (err) {
        alert(err.message);
      }
    };
    getCategory();
    getSubCategory();

    getBrandLists();
  }, []);

  const handleProAccessCode = (e) => {
    if (e.target.value.trim() !== "") {
      setError({
        ...error,
        procode: "",
      });
    }
    setProCode(e.target.value);
  };

  const handleProAccessNameChange = (e) => {
    if (e.target.value.trim() !== "") {
      setError({
        ...error,
        name: "",
      });
    }
    setName(e.target.value);
  };

  const handleCategoryChange = (e) => {
    if (e.target.value.trim() !== "") {
      setError({
        ...error,
        category: "",
      });
    }
    setCategory(e.target.value);
  };

  const handleSubCategoryChange = (e) => {
    if (e.target.value.trim() !== "") {
      setError({
        ...error,
        subCategory: "",
      });
    }
    setSubCategory(e.target.value);
  };

  const handleBrandChange = (e) => {
    if (e.target.value.trim() !== "") {
      setError({
        ...error,
        relatedBrand: "",
      });
    }
    setRelatedBrand(e.target.value);
  };

  return (
    <div>
      <Dialog open={props.open} onClose={props.close}>
        <DialogTitle>
          {" "}
          <div className="modal-header bg-info">
            <h4 className="modal-title">Create New Procedure Medicine</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.close}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          {/* @csrf */}
          <div class="modal-body">
            <div class="form-group">
              <label for="name">Code</label>
              <input
                type="text"
                class="form-control border border-info"
                name="code"
                onChange={handleProAccessCode}
              />
              {error.procode && <p style={{ color: "red" }}>{error.procode}</p>}
            </div>
            <div class="form-group">
              <label for="name">Name</label>
              <input
                type="text"
                class="form-control border border-info"
                name="name"
                placeholder="eg. mg mg"
                onChange={handleProAccessNameChange}
              />
              {error.name && <p style={{ color: "red" }}>{error.name}</p>}
            </div>
            <div class="form-group">
              <label for="name">Category</label>
              <select
                class="custom-select border-info"
                name="account_type_id"
                id="cat"
                onChange={handleCategoryChange}
              >
                <option hidden>Choose Category</option>
                {categoryLists.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
              {error.category && (
                <p style={{ color: "red" }}>{error.category}</p>
              )}
            </div>
            <div class="form-group">
              <label for="name">Sub Category</label>
              <select
                class="custom-select border-info"
                id="subCat"
                name="account_type_id"
                onChange={handleSubCategoryChange}
              >
                <option hidden>Choose Sub Category</option>
                {subCategoryLists.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
              {error.subCategory && (
                <p style={{ color: "red" }}>{error.subCategory}</p>
              )}
            </div>

            <div class="form-group">
              <label for="name">Choose Brand</label>
              <select
                name="currency"
                id=""
                className="form-control mt-1"
                onChange={handleBrandChange}
              >
                <option hidden>Choose Brand</option>

                {relatedBrandList.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
              {error.relatedBrand && (
                <p style={{ color: "red" }}>{error.relatedBrand}</p>
              )}
            </div>
            <div class="form-group">
              <label for="name">Description</label>
              <textarea
                className="form-control"
                id="description"
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <Button
              class="btn btn-secondary"
              data-dismiss="modal"
              onClick={props.close}
            >
              Close
            </Button>
            <Button class="btn btn-primary" onClick={ProMedicineCreate}>
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
// phyo
//maymyat
